import React, { useState } from 'react';
import usePWAInstall from '../hooks/usePWAInstall';

const InstallMenuItem = ({ onClose }) => {
  const { canInstall, isIOS, promptInstall } = usePWAInstall();
  const [showModal, setShowModal] = useState(false);

  if (!canInstall) return null;

  const handleClick = async () => {
    if (isIOS) {
      setShowModal(true);
      if (onClose) onClose();
    } else {
      await promptInstall();
      if (onClose) onClose();
    }
  };

  return (
    <>
      <li>
        <button onClick={handleClick} className="block text-blue-700 w-full text-left">
          ホーム画面に追加
        </button>
      </li>
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-30"
            onClick={() => setShowModal(false)}
          />
          <div className="relative bg-white p-4 rounded shadow text-center">
            <p className="mb-4">共有ボタンから「ホーム画面に追加」を選んでください</p>
            <button
              className="px-4 py-2 bg-blue-700 text-white rounded"
              onClick={() => setShowModal(false)}
            >
              閉じる
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallMenuItem;
